import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Check, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Admissions = () => {
 const forFamilies = [
 'Value depth of understanding over test scores',
 'Believe children deserve agency and respect',
 'Are willing to trust a new model',
 'Care about real-world skills and character development',
 'Want their child to be known deeply, not just managed',
 'Are prepared to be part of a founding community'
 ];

 const notForFamilies = [
 'Are looking for guaranteed exam results or rankings',
 'Expect a fully established system with no room for evolution',
 'Prioritise status, branding, or prestige over educational philosophy',
 'Want a traditional international school experience',
 'Are uncomfortable with alternative approaches to learning',
 'Need immediate certainty and familiar structures'
 ];

 return (
 <div className="admissions-page">
 <section className="page-hero">
 <div className="section-container">
 <h1 className="page-title">Admissions</h1>
 <p className="page-subtitle">
 Values alignment over speed.
 </p>
 </div>
 </section>

 <section className="admissions-intro-section">
 <div className="section-container">
 <p className="intro-text">
 Nova Roots is not for everyone—and that's intentional. We're building a learning community 
 where families are deeply aligned with the philosophy, committed to the approach, and ready 
 to trust the process.
 </p>
 </div>
 </section>

 <section className="for-section">
 <div className="section-container">
 <h2 className="section-title">Nova Roots Is For Families Who</h2>
 <div className="for-grid">
 {forFamilies.map((item, index) => (
 <div key={index} className="for-item">
 <div className="for-icon">
 <Check size={20} />
 </div>
 <p>{item}</p>
 </div>
 ))}
 </div>
 </div>
 </section>

 <section className="not-for-section">
 <div className="section-container">
 <h2 className="section-title">Nova Roots Is Not For Families Who</h2>
 <div className="not-for-grid">
 {notForFamilies.map((item, index) => (
 <div key={index} className="not-for-item">
 <div className="not-for-icon">
 <X size={20} />
 </div>
 <p>{item}</p>
 </div>
 ))}
 </div>
 </div>
 </section>

 <section className="process-section">
 <div className="section-container">
 <h2 className="section-title">The Admissions Process</h2>
 <div className="process-content">
 <Card className="process-card">
 <CardContent className="process-step">
 <h3>1. Register Interest</h3>
 <p>
 Complete the interest form sharing basic information about your family and child.
 </p>
 </CardContent>
 </Card>

 <Card className="process-card">
 <CardContent className="process-step">
 <h3>2. Initial Conversation</h3>
 <p>
 We'll schedule a conversation to discuss Nova Roots in depth, answer questions, and 
 explore whether there's alignment.
 </p>
 </CardContent>
 </Card>

 <Card className="process-card">
 <CardContent className="process-step">
 <h3>3. Family Visit</h3>
 <p>
 If there's mutual interest, families are invited to visit, meet Walezi, see the space, 
 and spend time understanding the environment.
 </p>
 </CardContent>
 </Card>

 <Card className="process-card">
 <CardContent className="process-step">
 <h3>4. Application</h3>
 <p>
 Families complete a detailed application sharing their educational values, child's needs, 
 and reasons for choosing Nova Roots.
 </p>
 </CardContent>
 </Card>

 <Card className="process-card">
 <CardContent className="process-step">
 <h3>5. Decision</h3>
 <p>
 Decisions are made based on alignment, readiness, and community fit—not competition or ranking.
 </p>
 </CardContent>
 </Card>
 </div>
 </div>
 </section>

 <section className="timeline-section">
 <div className="section-container">
 <div className="timeline-box">
 <h2>Timeline</h2>
 <p>
 Applications for September 2026 open throughout 2025. There is no deadline, but places are 
 limited. Early registration is encouraged.
 </p>
 <p>
 The process prioritises thoughtful conversation over speed. We take the time needed to ensure 
 genuine alignment.
 </p>
 </div>
 </div>
 </section>

 <section className="cta-section">
 <div className="section-container">
 <div className="cta-box">
 <h2>Start the Conversation</h2>
 <p>
 If Nova Roots feels aligned with what you want for your child, we'd love to hear from you.
 </p>
 <Link to="/contact">
 <Button className="cta-button">
 Register Interest <ArrowRight className="ml-2" size={18} />
 </Button>
 </Link>
 </div>
 </div>
 </section>
 </div>
 );
};

export default Admissions;